'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactModalify = require('react-modalify');

var _reactOnclickoutside = require('react-onclickoutside');

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _ModalifyWrapper = require('../components/ModalifyWrapper');

var _ModalifyWrapper2 = _interopRequireDefault(_ModalifyWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var defaultStyles = {
  overlayTransitionDuration: 125,
  overlayStyles: {
    justifyContent: 'center',
    zIndex: 1000
  },
  modalTransitionDuration: 125
};

var clickOutWrapper = (0, _reactOnclickoutside2.default)(_ModalifyWrapper2.default);

/**
 * Clean up after modalify.
 * Modalify leaves each modal mounted and in the dom,
 * unmount and remove each modal from within the overlay container.
 */
var handleAfterClose = function handleAfterClose(node) {
  // Force the unmount.
  if (node && node.parentNode) {
    _reactDom2.default.unmountComponentAtNode(node.parentNode);
  }
  // Ensure body always returns to no overflow when the modal closes.
  document.body.style.overflow = '';
  // Remove modal from the dom.
  var container = document.querySelector('body > div[style*="justify-content"]');
  container.childNodes.forEach(function (child) {
    container.removeChild(child);
  });
  document.body.removeChild(container);
};

var wrappedModalify = function wrappedModalify(Component, options) {
  var modalFactory = new _reactModalify.ModalFactory(defaultStyles);
  var createModal = modalFactory.create.bind(modalFactory);

  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(props) {
      var modalify;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              modalify = createModal(clickOutWrapper, options);
              return _context.abrupt('return', modalify(_extends({}, props, {
                ChildComponent: Component,
                afterClose: handleAfterClose
              })));

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.default = wrappedModalify;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/utilities/modalify.js
// module id = 287
// module chunks = 0